/**
 * Shopify Custom Wishlist Plugin v3
 */
(function () {
  'use strict';

  const cfg        = window.WishlistConfig || {};
  const API_URL    = (cfg.apiUrl    || '').replace(/\/$/, '');
  const API_SECRET = cfg.apiSecret  || '';
  const CURRENCY   = cfg.currency   || '₹';

  if (!API_URL) {
    console.warn('[Wishlist] WishlistConfig.apiUrl is not set. Plugin disabled.');
    return;
  }

  const LS_NAME_KEY  = 'wl_name';
  const LS_PHONE_KEY = 'wl_phone';
  const LS_ITEMS_KEY = 'wl_items';
  const LS_DATA_KEY  = 'wl_data';

  // ── Local state helpers ─────────────────────────────────
  function getName()    { return localStorage.getItem(LS_NAME_KEY)  || ''; }
  function saveName(n)  { localStorage.setItem(LS_NAME_KEY, n); }
  function getPhone()   { return localStorage.getItem(LS_PHONE_KEY) || ''; }
  function savePhone(p) { localStorage.setItem(LS_PHONE_KEY, p); }

  function getLocalItems() {
    try { return JSON.parse(localStorage.getItem(LS_ITEMS_KEY) || '{}'); }
    catch { return {}; }
  }
  function setLocalItem(id, val) {
    const items = getLocalItems();
    if (val) items[String(id)] = true;
    else delete items[String(id)];
    localStorage.setItem(LS_ITEMS_KEY, JSON.stringify(items));
    updateCounter();
  }
  function isWishlisted(id) { return !!getLocalItems()[String(id)]; }

  function getLocalData() {
    try { return JSON.parse(localStorage.getItem(LS_DATA_KEY) || '{}'); }
    catch { return {}; }
  }
  function saveLocalData(productData) {
    const data = getLocalData();
    data[String(productData.product_id)] = productData;
    localStorage.setItem(LS_DATA_KEY, JSON.stringify(data));
  }
  function removeLocalData(productId) {
    const data = getLocalData();
    delete data[String(productId)];
    localStorage.setItem(LS_DATA_KEY, JSON.stringify(data));
  }

  // ── Resolved user identity ──────────────────────────────
  // Two scenarios only:
  //   1) Returning user  — wl_phone exists in localStorage → skip modal
  //   2) New user        — no phone found → open modal
  function resolvedPhone() {
    return getPhone();
  }
  function resolvedName() {
    return getName();
  }

  // ── API calls ───────────────────────────────────────────
  async function apiCall(method, body) {
    const opts = {
      method,
      headers: {
        'Content-Type': 'application/json',
        'x-wishlist-secret': API_SECRET,
      },
    };
    if (body && method !== 'GET' && method !== 'HEAD') {
      opts.body = JSON.stringify(body);
    }
    const url = method === 'GET'
      ? `${API_URL}/api/wishlist?phone=${encodeURIComponent(body.phone)}`
      : `${API_URL}/api/wishlist`;
    const res = await fetch(url, opts);
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.error || `HTTP ${res.status}`);
    }
    return res.json();
  }

  async function apiAdd(phone, productData)   { return apiCall('POST',   { phone, ...productData }); }
  async function apiRemove(phone, product_id) { return apiCall('DELETE', { phone, product_id }); }
  async function apiGet(phone)                { return apiCall('GET',    { phone }); }

  // ── Sync from server ────────────────────────────────────
  async function syncFromServer() {
    const phone = resolvedPhone();
    updateCounter();
    if (!phone) return;

    try {
      const data = await apiGet(phone);
      const serverItems = data.wishlist || [];

      if (serverItems.length > 0) {
        const fresh = {};
        const dataCache = {};
        serverItems.forEach(entry => {
          fresh[entry.product_id] = true;
          dataCache[entry.product_id] = {
            product_id:       entry.product_id,
            product_title:    entry.product_title,
            product_handle:   entry.product_handle,
            variant_id:       entry.variant_id,
            product_image:    entry.product_image,
            product_price:    entry.product_price,
            compare_at_price: entry.compare_at_price || '',
            added_at:         entry.added_at,
          };
        });
        localStorage.setItem(LS_ITEMS_KEY, JSON.stringify(fresh));
        localStorage.setItem(LS_DATA_KEY, JSON.stringify(dataCache));
      }

      updateAllButtons();
      updateCounter();

      if (window.WishlistPage && typeof window.WishlistPage.refresh === 'function') {
        window.WishlistPage.refresh();
      }
    } catch (e) {
      console.warn('[Wishlist] Sync failed:', e.message);
      updateCounter();
    }
  }

  // ── Counter (badge in header) ───────────────────────────
  function updateCounter() {
    const items = getLocalItems();
    const count = Object.keys(items).length;

    document.querySelectorAll('[data-wishlist-count]').forEach(el => {
      el.textContent = count;
      if (count > 0) {
        el.style.cssText = 'display: flex !important; align-items: center; justify-content: center;';
        el.classList.add('is-visible');
        el.setAttribute('data-count', count);
      } else {
        el.style.cssText = 'display: none !important;';
        el.classList.remove('is-visible');
        el.removeAttribute('data-count');
      }
    });

    document.querySelectorAll('[data-wishlist-link]').forEach(el => {
      el.classList.toggle('has-items', count > 0);
    });
  }

  // ── Heart SVG state ─────────────────────────────────────
  function updateHeartSVG(btn) {
    const active = btn.classList.contains('is-wishlisted');
    btn.querySelectorAll('svg, svg g, svg path').forEach(el => {
      el.removeAttribute('style');
      if (active) {
        el.style.fill        = '#e63946';
        el.style.stroke      = '#e63946';
        el.style.strokeWidth = '2';
        el.style.opacity     = '1';
      } else {
        el.style.fill        = 'none';
        el.style.stroke      = '#333';
        el.style.strokeWidth = '4';
        el.style.opacity     = '1';
      }
    });
  }

  // ── Button state ────────────────────────────────────────
  function updateAllButtons() {
    document.querySelectorAll('.wishlist-btn[data-product-id]').forEach(btn => {
      const id     = btn.dataset.productId;
      const active = isWishlisted(id);
      btn.classList.toggle('is-wishlisted', active);
      btn.setAttribute('aria-label',   active ? 'Remove from wishlist' : 'Add to wishlist');
      btn.setAttribute('aria-pressed', String(active));
      updateHeartSVG(btn);
    });
  }

  function setButtonLoading(btn, loading) {
    btn.disabled = loading;
    if (loading) btn.classList.add('wl-loading');
    else btn.classList.remove('wl-loading');
  }

  // ── Toast ───────────────────────────────────────────────
  let toastTimer = null;
  function showToast(msg, type = 'success') {
    let toast = document.getElementById('wl-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'wl-toast';
      toast.className = 'wl-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = msg;
    toast.className = `wl-toast is-${type}`;
    void toast.offsetHeight;
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 2800);
  }

  // ── Modal ───────────────────────────────────────────────
  let pendingProductData = null;
  let pendingButton      = null;

  function openModal(btn, productData) {
    pendingProductData = productData;
    pendingButton      = btn;
    const overlay = document.getElementById('wl-modal-overlay');
    if (!overlay) return;

    const nameEl  = overlay.querySelector('.wl-modal__product-name');
    const priceEl = overlay.querySelector('.wl-modal__product-price');
    const imgEl   = overlay.querySelector('.wl-modal__product-img');
    const phEl    = overlay.querySelector('.wl-modal__product-img-placeholder');

    if (nameEl)  nameEl.textContent  = productData.product_title || '';
    if (priceEl) priceEl.textContent = productData.product_price ? `${CURRENCY}${productData.product_price}` : '';

    if (productData.product_image) {
      if (imgEl) { imgEl.src = productData.product_image; imgEl.style.display = 'block'; }
      if (phEl)   phEl.style.display = 'none';
    } else {
      if (imgEl)  imgEl.style.display = 'none';
      if (phEl)   phEl.style.display = 'flex';
    }

    const nameInput = overlay.querySelector('#wl-name-input');
    if (nameInput && getName()) nameInput.value = getName();

    const contactInput = overlay.querySelector('#wl-contact-input');
    if (contactInput && getPhone()) contactInput.value = getPhone();

    showModalForm(overlay);
    clearAllErrors(overlay);
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    if (nameInput && !nameInput.value) {
      setTimeout(() => nameInput.focus(), 250);
    } else if (contactInput) {
      setTimeout(() => contactInput.focus(), 250);
    }
  }

  function closeModal() {
    const overlay = document.getElementById('wl-modal-overlay');
    if (!overlay) return;
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    pendingProductData = null;
    pendingButton      = null;
  }

  function showModalForm(overlay) {
    overlay.querySelector('.wl-modal__form-section').style.display = 'block';
    overlay.querySelector('.wl-modal__success').classList.remove('is-visible');
  }
  function showModalSuccess(overlay) {
    overlay.querySelector('.wl-modal__form-section').style.display = 'none';
    overlay.querySelector('.wl-modal__success').classList.add('is-visible');
    setTimeout(() => closeModal(), 1800);
  }

  // ── Error helpers ───────────────────────────────────────
  function showFieldError(overlay, inputSelector, errorSelector, msg) {
    const errEl = overlay.querySelector(errorSelector);
    const input = overlay.querySelector(inputSelector);
    if (errEl) { errEl.textContent = msg; errEl.classList.add('is-visible'); }
    if (input) input.classList.add('has-error');
  }

  function clearFieldError(overlay, inputSelector, errorSelector) {
    const errEl = overlay.querySelector(errorSelector);
    const input = overlay.querySelector(inputSelector);
    if (errEl) { errEl.textContent = ''; errEl.classList.remove('is-visible'); }
    if (input) input.classList.remove('has-error');
  }

  function clearAllErrors(overlay) {
    clearFieldError(overlay, '#wl-name-input',    '#wl-name-error');
    clearFieldError(overlay, '#wl-contact-input', '#wl-phone-error');
  }

  // ── Validation ──────────────────────────────────────────
  // The customer must type their own country code (e.g. +91 98765 43210).
  // We don't assume a country for them — if they enter exactly 10 digits
  // (a bare local number with no country code), we ask for the country
  // code explicitly instead of guessing. Anything with 11-15 digits is
  // treated as "has a country code" and passed through as-is.
  function normalizePhone(value) {
    const digits = (value || '').replace(/\D/g, '');
    if (digits.length >= 11 && digits.length <= 15) return digits;
    return null;
  }

  function validateContact(value) {
    const v = value.trim();
    const emailRegex = /^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/;
    if (emailRegex.test(v)) return null;

    const digits = v.replace(/\D/g, '');
    if (digits.length === 10) {
      return 'Please include your country code as well (e.g. +91 for India).';
    }
    if (normalizePhone(v)) return null;
    return 'Please enter a valid phone number with country code, or an email address.';
  }

  // Returns the value that should actually be sent to the API.
  function resolveContactForSubmit(value) {
    const v = value.trim();
    const emailRegex = /^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/;
    if (emailRegex.test(v)) return v;
    return normalizePhone(v) || v;
  }

  async function submitModal() {
    const overlay      = document.getElementById('wl-modal-overlay');
    const contactInput = overlay.querySelector('#wl-contact-input');
    const nameInput    = overlay.querySelector('#wl-name-input');
    const btn          = overlay.querySelector('#wl-modal-submit');
    if (!contactInput || !overlay) return;

    const contact = contactInput.value.trim();
    const name    = nameInput ? nameInput.value.trim() : '';

    clearAllErrors(overlay);

    let hasError = false;

    if (!name) {
      showFieldError(overlay, '#wl-name-input', '#wl-name-error', 'Please enter your name.');
      hasError = true;
    }

    const contactErr = validateContact(contact);
    if (contactErr) {
      showFieldError(overlay, '#wl-contact-input', '#wl-phone-error', contactErr);
      hasError = true;
    }

    if (hasError) {
      if (!name && nameInput) nameInput.focus();
      else if (contactErr && contactInput) contactInput.focus();
      return;
    }

    btn.disabled    = true;
    btn.textContent = 'Saving...';

    try {
      const contactToSend = resolveContactForSubmit(contact); // e.g. 9876543210 -> 919876543210
      const dataToSend = { ...pendingProductData, customer_name: name };
      await apiAdd(contactToSend, dataToSend);
      savePhone(contactToSend);
      saveName(name);
      setLocalItem(pendingProductData.product_id, true);
      saveLocalData(pendingProductData);

      updateAllButtons();
      if (pendingButton) {
        pendingButton.classList.add('wl-animate');
        setTimeout(() => pendingButton.classList.remove('wl-animate'), 400);
      }
      showModalSuccess(overlay);
    } catch (e) {
      showFieldError(overlay, '#wl-contact-input', '#wl-phone-error', 'Something went wrong. Please try again.');
      console.error('[Wishlist] Add failed:', e);
    } finally {
      btn.disabled    = false;
      btn.textContent = 'Save to Wishlist';
    }
  }

  // ── Click handler ───────────────────────────────────────
  async function handleWishlistClick(btn) {
    const productId = btn.dataset.productId;
    if (!productId) return;

    const productData = {
      product_id:       productId,
      product_title:    btn.dataset.productTitle  || '',
      product_handle:   btn.dataset.productHandle || '',
      variant_id:       btn.dataset.variantId     || '',
      product_image:    btn.dataset.productImage  || '',
      product_price:    btn.dataset.productPrice  || '',
      compare_at_price: btn.dataset.comparePrice  || '',
    };

    // ── REMOVE flow ─────────────────────────────────────
    if (isWishlisted(productId)) {
      const phone = resolvedPhone();
      setButtonLoading(btn, true);
      
      // Try to remove from API if phone exists, but don't fail if it does
      if (phone) {
        try {
          await apiRemove(phone, productId);
        } catch (e) {
          console.warn('[Wishlist] API remove failed, removing locally:', e.message);
          // Continue with local removal even if API fails
        }
      }
      
      // Always remove locally
      setLocalItem(productId, false);
      removeLocalData(productId);
      updateAllButtons();
      showToast('Removed from wishlist', 'success');
      
      if (window.WishlistPage && typeof window.WishlistPage.refresh === 'function') {
        window.WishlistPage.refresh();
      }
      
      setButtonLoading(btn, false);
      return;
    }

    // ── ADD flow ────────────────────────────────────────
    const phone = resolvedPhone();
    const name  = resolvedName();

    if (phone) {
      setButtonLoading(btn, true);
      try {
        const dataToSend = { ...productData, customer_name: name };
        await apiAdd(phone, dataToSend);
        setLocalItem(productId, true);
        saveLocalData(productData);

        updateAllButtons();
        btn.classList.add('wl-animate');
        setTimeout(() => btn.classList.remove('wl-animate'), 400);
        showToast('Added to wishlist!', 'success');
      } catch (e) {
        showToast('Could not add to wishlist. Try again.', 'error');
      } finally {
        setButtonLoading(btn, false);
      }
      return;
    }

    // No phone found → open modal
    openModal(btn, productData);
  }

  function initButtons() {
    document.addEventListener('click', function (e) {
      const btn = e.target.closest('.wishlist-btn[data-product-id]');
      if (btn) {
        e.preventDefault();
        e.stopPropagation();
        handleWishlistClick(btn);
      }
    });
  }

  function initModal() {
    const overlay = document.getElementById('wl-modal-overlay');
    if (!overlay) return;

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeModal();
    });

    overlay.querySelector('.wl-modal__close')?.addEventListener('click', closeModal);
    overlay.querySelector('#wl-modal-submit')?.addEventListener('click', submitModal);

    overlay.querySelector('#wl-name-input')?.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        const contactInput = overlay.querySelector('#wl-contact-input');
        if (contactInput && !contactInput.value.trim()) {
          contactInput.focus();
        } else {
          submitModal();
        }
      }
    });

    overlay.querySelector('#wl-contact-input')?.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); submitModal(); }
    });

    // This field accepts either a phone number OR an email — so only strip
    // non-digit characters while the value doesn't look like an email in
    // progress (no "@" typed yet). Once "@" appears, leave it alone.
    overlay.querySelector('#wl-contact-input')?.addEventListener('input', function (e) {
      let v = e.target.value;
      if (v.includes('@')) return; // typing an email — don't touch it
      const hasLeadingPlus = v.trim().startsWith('+');
      let digits = v.replace(/\D/g, '').slice(0, 15);
      const cleaned = (hasLeadingPlus ? '+' : '') + digits;
      if (cleaned !== v) e.target.value = cleaned;
    });

    overlay.querySelector('#wl-name-input')?.addEventListener('input', function () {
      clearFieldError(overlay, '#wl-name-input', '#wl-name-error');
    });
    overlay.querySelector('#wl-contact-input')?.addEventListener('input', function () {
      clearFieldError(overlay, '#wl-contact-input', '#wl-phone-error');
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });
  }

  // ── Helpers ─────────────────────────────────────────────
  function esc(s) {
    return String(s || '')
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function https(url) {
    if (!url) return '';
    return url.startsWith('//') ? 'https:' + url : url;
  }

  function formatMoney(paise) {
    const amount = paise / 100;
    return '₹' + amount.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }

  // ── Wishlist page renderer ──────────────────────────────
  // The wishlist grid is server-rendered (same 'product-card' + quick-buy
  // markup as the collection page) via <wishlist-grid-products>, which
  // fetches `/search?q=id:X OR id:Y&section_id=...` — see
  // sections/wishlist-grid.liquid and the WishlistGridProducts element below.
  // This function just asks that element to reload.
  async function renderWishlistPage() {
    const el = document.querySelector('wishlist-grid-products');
    if (el && typeof el.loadProducts === 'function') {
      await el.loadProducts();
    }
  }

  async function removeFromWishlistAndRefresh(productId) {
    const phone = resolvedPhone();
    if (phone) {
      try { await apiRemove(phone, productId); } catch (e) { /* silent */ }
    }
    setLocalItem(productId, false);
    removeLocalData(productId);
    updateAllButtons();
    showToast('Removed from wishlist', 'success');
    renderWishlistPage();
  }

  // ── Add to Cart via AJAX (for wishlist page) ────────────
  window.submitWishlistCart = function(event, formId) {
    event.preventDefault();
    const form = document.getElementById(formId);
    if (!form) return;

    const formData = new FormData(form);
    const button = event.target;
    const originalText = button.textContent;
    
    button.disabled = true;
    button.textContent = 'Adding...';

    fetch(form.action, {
      method: 'POST',
      body: formData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => response.json())
    .then(data => {
      // Fetch the updated cart to get accurate count
      return fetch('/cart.json')
        .then(res => res.json())
        .then(cart => {
          // Dispatch cart:change event with correct data structure
          const event = new CustomEvent('cart:change', {
            detail: {
              cart: cart,
              item_count: cart.item_count,
              total_price: cart.total_price
            }
          });
          document.documentElement.dispatchEvent(event);
          
          button.textContent = 'Added!';
          setTimeout(() => {
            button.disabled = false;
            button.textContent = originalText;
          }, 800);
        });
    })
    .catch(error => {
      console.error('Add to cart error:', error);
      button.disabled = false;
      button.textContent = originalText;
    });
  };

  // ── <wishlist-grid-products> ─────────────────────────────
  // Mirrors the theme's own <recently-viewed-products> pattern: fetch the
  // search results page for the wishlisted product IDs, requesting just this
  // section's HTML, then swap in the server-rendered markup. Because the
  // section renders the real 'product-card' snippet (with show_quick_buy),
  // the cards — including size selection via the quick-buy modal, and its
  // add-to-cart which is the real product-info form — are identical to the
  // collection page, not a hand-built approximation.
  class WishlistGridProducts extends HTMLElement {
    connectedCallback() {
      this.loadProducts();
    }

    searchQueryString() {
      const ids = Object.keys(getLocalItems());
      return ids.slice(0, 48).map(id => `id:${id}`).join(' OR ');
    }

    async loadProducts() {
      const section = this.closest('.shopify-section');
      if (!section) return;

      const sectionId = section.id.replace('shopify-section-', '');
      // 'id:0' deliberately matches nothing — it still marks the search as
      // "performed" server-side, so an empty wishlist renders the real
      // empty-state snippet instead of us faking one here.
      const query = this.searchQueryString() || 'id:0';
      const url = `${Shopify.routes.root}search?type=product&q=${encodeURIComponent(query)}&section_id=${sectionId}`;

      try {
        const res  = await fetch(url, { priority: 'low' });
        const html = await res.text();
        const tempDoc = new DOMParser().parseFromString(html, 'text/html');

        const newHeading = tempDoc.getElementById('wl-page-heading');
        const heading     = document.getElementById('wl-page-heading');
        if (newHeading && heading) heading.innerHTML = newHeading.innerHTML;

        const newGrid = tempDoc.querySelector('wishlist-grid-products');
        if (newGrid) {
          this.replaceChildren(...document.importNode(newGrid, true).childNodes);
        }

        updateAllButtons();
      } catch (e) {
        console.error('[Wishlist] Failed to load wishlist products:', e);
      }
    }
  }
  if (!window.customElements.get('wishlist-grid-products')) {
    window.customElements.define('wishlist-grid-products', WishlistGridProducts);
  }

  function boot() {
    updateAllButtons();
    updateCounter();
    initButtons();
    initModal();
    setInterval(updateCounter, 1000);
    syncFromServer();

    // Product cards (with their wishlist buttons) get swapped in via AJAX on
    // collection/search filtering — re-sync the is-wishlisted state once that
    // swap actually lands in the DOM, so newly-rendered cards don't default
    // to an empty heart. (theme:section:updated fires after the swap; the
    // earlier facet:update fires before it, while the fetch is still in flight.)
    document.addEventListener('theme:section:updated', updateAllButtons);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.WishlistPlugin = {
    updateAllButtons,
    updateCounter,
    openModal,
    getLocalItems,
    getLocalData,
    isWishlisted,
    apiRemove,
    setLocalItem,
    removeLocalData,
    getPhone: resolvedPhone,
    getName:  resolvedName,
    removeFromWishlistAndRefresh,
  };

  window.WishlistPage = {
    refresh: renderWishlistPage,
  };

})();